/* ============================================================
   VIRELLO — global interactions (v4: full)
   ============================================================ */
(function () {
  'use strict';

  /* Nav scroll state + dark-section detection */
  function initNav() {
    var nav = document.querySelector('.v-nav');
    if (!nav) return;
    var darkSections = Array.prototype.slice.call(document.querySelectorAll('[data-dark]'));
    function onScroll() {
      nav.classList.toggle('scrolled', window.scrollY > 30);
      var navMid = 32, inDark = false;
      for (var i = 0; i < darkSections.length; i++) {
        var r = darkSections[i].getBoundingClientRect();
        if (r.top <= navMid && r.bottom >= navMid) { inDark = true; break; }
      }
      document.body.classList.toggle('dark', inDark);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* Reveal-on-scroll */
  function initReveal() {
    var els = document.querySelectorAll('.reveal');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* Sticky horizontal showcase */
  function initShowcase() {
    var showcase = document.querySelector('[data-showcase]');
    if (!showcase) return;
    var track    = showcase.querySelector('[data-showcase-track]');
    var progress = showcase.querySelector('[data-showcase-progress]');
    var counter  = showcase.querySelector('[data-showcase-counter]');
    var count    = parseInt(showcase.getAttribute('data-panel-count'), 10) || 4;
    if (!track) return;
    function pad(n) { return n < 10 ? ('0' + n) : ('' + n); }
    function tick() {
      if (window.innerWidth <= 900) {
        track.style.transform = '';
        if (progress) progress.style.width = '0';
        return;
      }
      var rect  = showcase.getBoundingClientRect();
      var total = showcase.offsetHeight - window.innerHeight;
      var raw   = Math.max(0, Math.min(1, -rect.top / total));
      track.style.transform = 'translate3d(' + (-raw * 100 * (count - 1)) + 'vw, 0, 0)';
      if (progress) progress.style.width = (raw * 100) + '%';
      if (counter)  counter.textContent  = pad(Math.min(count, Math.floor(raw * count) + 1));
    }
    window.addEventListener('scroll', tick, { passive: true });
    window.addEventListener('resize', tick);
    tick();
  }

  /* Compatibility checker (standalone section) */
  function initCompatChecker() {
    var card = document.querySelector('[data-compat-checker]');
    if (!card) return;
    var osSel   = card.querySelector('[data-compat-os]');
    var sizeSel = card.querySelector('[data-compat-size]');
    var portSel = card.querySelector('[data-compat-port]');
    var result  = card.querySelector('[data-compat-result]');
    var text    = card.querySelector('[data-compat-result-text]');
    if (!portSel || !result || !text) return;

    /* Real product data injected by the section (from metafields) */
    var products = [];
    var dataEl = document.querySelector('[data-compat-products]');
    if (dataEl) { try { products = JSON.parse(dataEl.textContent) || []; } catch (e) { products = []; } }

    function parseFits(s) {
      if (!s) return null;
      var nums = String(s).replace(/,/g, '.').match(/[0-9]+(?:\.[0-9]+)?/g);
      if (!nums || !nums.length) return null;
      var min = parseFloat(nums[0]);
      var max = nums.length > 1 ? parseFloat(nums[1]) : min;
      return { min: min, max: max };
    }
    function connOk(conn, port) {
      var c = (conn || '').toLowerCase();
      if (!c) return true;
      if (port === 'hdmi-only') return c.indexOf('hdmi') !== -1;
      if (port === 'dp-alt')    return c.indexOf('usb-c') !== -1 || c.indexOf('usb c') !== -1 || c.indexOf('onecable') !== -1;
      return true;
    }
    function matchProducts(size, port) {
      return products.filter(function (p) {
        var f = parseFits(p.fits), sizeOk = true;
        if (f && !isNaN(size)) sizeOk = size >= (f.min - 0.05) && size <= (f.max + 0.05);
        return sizeOk && connOk(p.connection, port);
      });
    }
    function link(p) { return '<strong><a href="' + p.url + '">' + p.title + '</a></strong>'; }

    function decide() {
      var size = parseFloat(sizeSel ? sizeSel.value : '');
      var port = portSel.value;
      var matches = matchProducts(size, port);

      if (port === 'unsure') {
        return { warn: true, html: 'We can’t confirm without your USB-C port type. Most laptops from 2020+ support DP Alt Mode — check your specs for "DisplayPort over USB-C".' };
      }
      if (port === 'hdmi-only') {
        if (matches.length) return { warn: true, html: 'Your laptop uses HDMI. The ' + link(matches[0]) + ' supports it — add the HDMI cable bundle at checkout.' };
        return { warn: true, html: 'Your laptop only has HDMI — choose a model with HDMI support and add the HDMI bundle.' };
      }
      if (matches.length) {
        return { warn: false, html: 'Compatible. We recommend the ' + link(matches[0]) + (isNaN(size) ? '.' : ' for your ' + size + '″ laptop.') };
      }
      return { warn: false, html: 'Compatible with most modern laptops. Browse the range to pick your size.' };
    }
    function update() {
      var r = decide();
      result.classList.toggle('warn', !!r.warn);
      var c = result.querySelector('.compat-check');
      if (c) c.textContent = r.warn ? '!' : '✓';
      text.innerHTML = r.html;
    }
    [osSel, sizeSel, portSel].forEach(function (el) { if (el) el.addEventListener('change', update); });
    update();
  }

  /* Apple-style scroll depth: images scale up + parallax as they pass through the viewport */
  function initDepth() {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var els = Array.prototype.slice.call(
      document.querySelectorAll('.panel--split .stage img, .panel--hero .hero-stage img')
    );
    if (!els.length) return;
    var ticking = false;
    function apply() {
      var vh = window.innerHeight || document.documentElement.clientHeight;
      for (var i = 0; i < els.length; i++) {
        var el = els[i];
        var r = el.getBoundingClientRect();
        if (r.bottom < -240 || r.top > vh + 240) continue;       // skip far off-screen
        var d = ((r.top + r.height / 2) - vh / 2) / vh;           // 0 = centred, ±1 = edges
        if (d > 1) d = 1; else if (d < -1) d = -1;
        var scale = 1 - Math.abs(d) * 0.10;                        // 0.90 at edges → 1.0 centred
        var ty = d * 34;                                           // gentle parallax drift
        el.style.transform = 'translate3d(0,' + ty.toFixed(1) + 'px,0) scale(' + scale.toFixed(3) + ')';
      }
      ticking = false;
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(apply); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    apply();
  }

  function init() { initNav(); initReveal(); initShowcase(); initCompatChecker(); initDepth(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();